import { useNavigate, useParams } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit/dist/hooks";
import { Chip, IconButton } from "@mui/material";
import { FarmIcon } from "components/Icons/Icons";
import { formatNumber, formatPracticeName } from "utility/formatters";

import { TilleyCard } from "../../../Cards/TilleyCard";
import { DeleteIcon } from "../../../Icons/Icons";
import { CROP_YEAR_POTENTIAL } from "../helpers";

export default function ProducerFarmCropCard({ currentProducerFarmCrop, onChange }) {
  const navigate = useNavigate();
  const { crop_year, location_state_name, location_county_name } = useParams();

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this farm?",
      promptDetail: "Warning: deleting a farm removes crops from ALL YEARS.",
      callback: () => {
        const _newState = { ...currentProducerFarmCrop };
        _newState.is_active = false;
        onChange?.(_newState);
      },
    });
  };

  return (
    <>
      <TilleyCard
        data-testid={`Open-${currentProducerFarmCrop?.farm_name ? currentProducerFarmCrop?.farm_name : currentProducerFarmCrop?.fsa_farm_number}-#${currentProducerFarmCrop?.fsa_farm_number}`}
        onClick={() =>
          navigate(`/vault/${crop_year}/${location_state_name}/${location_county_name}/${currentProducerFarmCrop?.id}`)
        }
        Avatar={FarmIcon}
        title={currentProducerFarmCrop?.farm_name}
        subtitle={"FSN " + currentProducerFarmCrop?.fsa_farm_number}
        action={
          crop_year === CROP_YEAR_POTENTIAL && (
            <IconButton
              data-testid={`Delete ${currentProducerFarmCrop?.farm_name ? currentProducerFarmCrop?.farm_name : currentProducerFarmCrop?.fsa_farm_number} - #${currentProducerFarmCrop?.fsa_farm_number}`}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteOnClick();
              }}
            >
              <DeleteIcon />
            </IconButton>
          )
        }
        details={[
          {
            value: formatNumber(currentProducerFarmCrop?.reported_acreage, 0),
            label: "ACRES",
          },
          {
            value: formatNumber(currentProducerFarmCrop?.base_acreage, 0),
            label: "BASE ACRES",
          },
        ]}
        footer={
          <>
            {currentProducerFarmCrop?.CropProfiles?.map((currentCropProfile, index) => (
              <Chip
                key={index}
                label={currentCropProfile?.commodity_name + " " + formatPracticeName(currentCropProfile?.practice_name)}
              />
            ))}
          </>
        }
      />
      {confirmDialogComponent}
    </>
  );
}
